<a #emailContainer class="email-container" href="mailto:{{ email }}">
  {{ email }}
</a>
